export default __webpack_public_path__ + "static/media/423486644_0b6916fa-50d0-47e8-ac25-715d3d79af5f.577d6493.jpg";